export default {
  OPEN_BULK_COPY: 'copy-location-setting-link:click',
  NOTIFICATION_SAVED: 'locations:settings:notifications:saved',
  SETTINGS_SAVED: 'locations:settings:saved',
  RUN_GEOFENCE_EMBED: 'locations:settings:geofence:run-embed',
  RUN_CONSENT_EMBED: 'locations:settings:consent:run-embed',
  RUN_AVAILABILITY_REMINDER_EMBED:
    'locations:settings:availability-reminder:run-embed',
  RUN_REQUIRE_CONSENT_DECLINE_COMMENT_EMBED:
    'locations:settings:require-consent-decline-comment:run-embed',
  GET_CLOSED_DAYS_AS_LEAVE_NON_WORKING:
    'LOCATION:SETTINGS:GET_CLOSED_DAYS_AS_LEAVE_NON_WORKING',
  GET_PUBLIC_HOLIDAYS_AS_LEAVE_NON_WORKING:
    'LOCATION:SETTINGS:GET_PUBLIC_HOLIDAYS_AS_LEAVE_NON_WORKING',
  ATTACHMENT_LOADING: 'LOCATION:SETTINGS:ATTACHMENT:LOADING',
  ATTACHMENT_LOADED: 'LOCATION:SETTINGS:ATTACHMENT:LOADED',
  ATTACHMENT_ERROR: 'LOCATION:SETTINGS:ATTACHMENT:ERROR',
  SCHEDULE_CONSENT_REGULATION_CHANGED:
    'locations:settings:schedule-consent-regulation:changed',
  RUN_LOCATION_TIMESHEET_AUTO_APPROVE_AND_ROUND_EMBED:
    'locations:settings:timesheet-auto-approve-and-round:run-embed',
};
